/* eslint-disable @typescript-eslint/no-explicit-any */
export function objectToQueryString(obj: any) {
  const str: string[] = []
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      if (obj[p] === null || obj[p] === undefined) continue
      if (Array.isArray(obj[p])) {
        if (obj[p].length === 0) {
          // no op (sending empty arrays/lists seems to be not really supported
          //in asp.net core (or query parameters in general?), at least without custom model binding)
        } else {
          obj[p].map((x: any) =>
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(x))
          )
        }
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
      }
    }
  return str.join("&")
}
